<div
    grid
    [columns]="dataSource?.columns"
    [gridTpl]="gridTpl"
    [rowTpl]="rowTpl"
    #grid="grid"
></div>

<ng-template #gridTpl>
    <table class="table"></table>
</ng-template>

<ng-template #rowTpl>
    <tr></tr>
</ng-template>

<ng-template
    #thTpl
    let-c="c"
    let-r="r"
    let-l="l"
    let-ctx="ctx"
>
    <th>
        <div
            [ngClass]="{
                'text-center':
                    l.def.columnType === ColumnType.LAST_MODIFIED ||
                    l.def.columnType === ColumnType.STATUS
            }"
        >
            <button
                type="button"
                class="cmps-btn-table tdcf-sort"
                tabindex="-1"
                [attr.aria-label]="
                    (i18n._7216_SORT_BY | translate) +
                    ' ' +
                    (columnName(c) | translate)
                "
                (click)="onSortClick(c)"
            >
                <span>
                    {{ columnName(c) | translate }}
                    <cmps-icon [svgIcon]="l.def.sortClassList"></cmps-icon>
                </span>
            </button>
        </div>
    </th>
</ng-template>

<ng-template
    #tdTpl
    let-c="c"
    let-r="r"
    let-l="l"
    let-ctx="ctx"
>
    <td
        class="tdcf-row"
        (click)="onExpandClick($event, c, r, l, ctx)"
    >
        <ng-container [ngSwitch]="c.type">
            <div
                *ngSwitchCase="ColumnType.QUARTER"
                class="tdcf-quarter-name"
                [ngStyle]="{
                    'padding-left': 'calc(1.5rem * ' + r.def.ctx.level + ')'
                }"
            >
                <button
                    type="button"
                    class="cmps-btn-table tdcf-expand"
                    tabindex="-1"
                    [attr.aria-label]="
                        (r.def.ctx.expanded ? i18n._7217_HIDE : i18n._7218_SHOW)
                            | translate
                    "
                    (click)="onExpandClick($event, c, r, l, ctx)"
                >
                    <cmps-icon
                        [svgIcon]="
                            r.def.ctx.expanded
                                ? 'chevron-down'
                                : 'chevron-right'
                        "
                    ></cmps-icon>
                </button>
                <div class="tdcf-icon">
                    <cmps-icon svgIcon="file"></cmps-icon>
                </div>
                {{ cellValue(c, l, r) | translate }}
            </div>
            <div
                *ngSwitchCase="ColumnType.LAST_MODIFIED"
                class="text-center"
            >
                {{ cellValue(c, l, r) | translate }}
            </div>
            <div
                *ngSwitchCase="ColumnType.STATUS"
                class="text-center"
            >
                <span
                    [ngClass]="{
                        'tdcf-status-pending':
                            l.def.ctx.status === Status.PENDING
                    }"
                    >{{ cellValue(c, l, r) | translate }}</span
                >
            </div>
            <div
                *ngSwitchCase="ColumnType.NAME"
                class="tdcf-quarter-name"
                [ngStyle]="{
                    'padding-left': 'calc(1.6rem * ' + r.def.ctx.level + ')'
                }"
            >
                <button
                    type="button"
                    class="cmps-btn-table tdcf-expand"
                    tabindex="-1"
                    [attr.aria-label]="
                        (r.def.ctx.expanded ? i18n._7217_HIDE : i18n._7218_SHOW)
                            | translate
                    "
                    (click)="onExpandClick($event, c, r, l, ctx)"
                >
                    <cmps-icon
                        [svgIcon]="
                            r.def.ctx.expanded
                                ? 'chevron-down'
                                : 'chevron-right'
                        "
                    ></cmps-icon>
                </button>
                <div class="tdcf-icon">
                    <cmps-icon
                        svgIcon="account-circle"
                        *ngIf="r.def.type === RowType.USER"
                    ></cmps-icon>
                    <cmps-icon
                        svgIcon="file"
                        *ngIf="r.def.type === RowType.ENTRY"
                    ></cmps-icon>
                </div>
                {{ cellValue(c, l, r) | translate }}
            </div>
        </ng-container>
    </td>
</ng-template>

<ng-template
    #tdFormTpl
    let-c="c"
    let-r="r"
    let-l="l"
    let-ctx="ctx"
>
    <td colspan="3">
        <div
            class="tdcf-form"
            [ngStyle]="{
                'padding-left': 'calc(1.8rem * ' + r.def.ctx.level + ')'
            }"
        >
            <div
                cmpsTdcfForm
                [mode]="mode"
                [templateId]="templateId"
                [payload]="ctx"
                [info]="info"
                [reviewDateRanges]="metadata.reviewDateRanges"
                (payloadChange)="onPayloadChange($event, r)"
            ></div>
        </div>
    </td>
</ng-template>

<ng-template #noDataTpl>
    <td colspan="3">
        <div class="text-center">
            {{ i18n._711_NO_DATA_AVAILABLE | translate }}
        </div>
    </td>
</ng-template>
